import React from "react";

const SharesTransfer = () => {
  return <div>SharesTransfer</div>;
};

export default SharesTransfer;
